import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import SportHub from "@/pages/SportHub";
import LiveScores from "@/pages/LiveScores";
import AthleteProfile from "@/pages/AthleteProfile";
import { TeamPage, CompetitionPage } from "@/pages/Entities";
import { ArticlePage, NewsList, SearchPage, VideosPage, CompetitionsList, AbroadPage, NotFound } from "@/pages/Content";
import { AuthProvider, AdminLogin, AdminLayout } from "@/pages/admin/AdminShell";
import { Dashboard, Logs, ContentTable, NewStory } from "@/pages/admin/AdminPages";
import { LangProvider } from "@/lib/i18n";

const ScrollTop = () => { const { pathname } = useLocation(); useEffect(() => window.scrollTo(0, 0), [pathname]); return null; };

const PublicLayout = () => (
  <>
    <Header />
    <main className="min-h-[60vh]"><Outlet /></main>
    <Footer />
  </>
);

const SPORTS = ["football", "basketball", "athletics", "combat", "handball", "volleyball", "women", "more"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <LangProvider>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              {SPORTS.map((s) => <Route key={s} path={`/${s}`} element={<SportHub slug={s} />} />)}
              <Route path="/more-sports" element={<SportHub slug="more" />} />
              <Route path="/live-scores" element={<LiveScores />} />
              <Route path="/athletes/:slug" element={<AthleteProfile />} />
              <Route path="/teams/:slug" element={<TeamPage />} />
              <Route path="/competitions" element={<CompetitionsList />} />
              <Route path="/competitions/:slug" element={<CompetitionPage />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:slug" element={<ArticlePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/videos" element={<VideosPage />} />
              <Route path="/cameroonians-abroad" element={<AbroadPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="new-story" element={<NewStory />} />
              <Route path="logs" element={<Logs />} />
              <Route path=":coll" element={<ContentTable />} />
            </Route>
          </Routes>
        </AuthProvider>
        </LangProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
